import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-html-editor',
    templateUrl: './html-editor.dialog.html',
    styleUrls: ['./html-editor.dialog.scss'],
    standalone: false
})
export class HtmlEditorDialog implements OnInit {

    private html: string;

    constructor(@Inject(MAT_DIALOG_DATA) data) {
        this.html = data.html;
    }

    public getEditorCssDefaults(): string {
        return `
        .k-content {
            font-family:Arial;
        }`
    };

    ngOnInit(): void {
    }

    public get Html(): string {
        return this.html;
    }

    public set Html(html: string) {
        this.html = html;
    }
}
